"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateKeys = void 0;
var cache = new WeakMap();
function generateKeys(translations) {
    if (!cache.has(translations)) {
        cache.set(translations, composePaths(translations));
    }
    return cache.get(translations);
}
exports.generateKeys = generateKeys;
function composePaths(lookup, path, result) {
    if (path === void 0) { path = []; }
    if (result === void 0) { result = {}; }
    for (var _i = 0, _a = Object.entries(lookup); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        var fullPath = __spreadArray(__spreadArray([], path, true), [key], false);
        if (typeof value === 'string') {
            var pathString = fullPath.join('.');
            result[pathString] = pathString;
        }
        else {
            composePaths(value, fullPath, result);
        }
    }
    return result;
}
